/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { validateAuthFields } from '../../redux/validateAuthFields';
import { LoginAction, LoginActionTypes } from './actions';

export interface LoginState {
  loading: boolean;
  error?: any;
  loginFields: {
    email?: string;
    password?: string;
    verificationCode?: string;
    phone?: string;
  };
}

export const initialLoginState: LoginState = {
  loading: false,
  loginFields: {
    email: '',
    password: '',
    verificationCode: '',
    phone: '',
  },
};

export default function loginReducer(state = initialLoginState, action: LoginAction): LoginState {
  switch (action.type) {
    case LoginActionTypes.LOGIN_REQUEST: {
      return update(state, {
        loading: { $set: true },
      });
    }

    case LoginActionTypes.LOGIN_ERROR:
      return update(state, {
        error: { $set: action.error },
        loading: { $set: false },
      });

    case LoginActionTypes.LOGIN_SUCCESS:
      return update(state, {
        $unset: ['error'],
        loading: { $set: false },
      });

    case LoginActionTypes.SET_LOGIN_FIELD:
      return validateAuthFields(state, { [action.field]: action.value }, 'loginFields');

    default:
      return state;
  }
}
